/**
 * Enum representing the possible statuses of an invoice in the list view.
 * Used for filtering invoices based on their current status.
 */
export enum ListInvoiceStatus {
    ALL = 'ALL',
    DRAFT = 'DRAFT',
    CREATED = 'CREATED',
    UNAPPROVED = 'UNAPPROVED',
    APPROVED = 'APPROVED',
    CANCELED = 'CANCELED',
    REJECTED = 'REJECTED',
    PAID = 'PAID',
}
